export default __webpack_public_path__ + "static/media/how2.20e20653.png";